import React, { useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import _, { isEmpty } from "lodash";
import { useDispatch } from "react-redux";
import playerImg from "assets/images/ct/player.png";
import hammer from "assets/images/ct/hammer.png";
import icons from "assets/images/ct/icons.png";
import tech from "assets/images/ct/tech.png";
import schemes from "assets/images/ct/schemes.png";
import random from "assets/images/ct/random.png";
import mythos from "assets/images/ct/mythos.png";
import aliens from "assets/images/ct/aliens.png";
import ctTechCircleSymbol from "assets/images/ct/ctTechCircleSymbol.png";
import ctSchemesCircleSymbol from "assets/images/ct/ctSchemesCircleSymbol.png";
import ctAliensCircleSymbol from "assets/images/ct/ctAliensCircleSymbol.png";
import ctRandomCircleSymbol from "assets/images/ct/ctRandomCircleSymbol.png";
import ctMythosCircleSymbol from "assets/images/ct/ctMythosCircleSymbol.png";
import CTDash from "assets/images/ct/CTDash.png";
import CTDash2 from "assets/images/ct/CTDash2.png";

import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";
const CtHighFivePlayerList = ({
  playersWithCardInfo,
  playerSelected,
  set_ct_selected_player,
  set_ct_selected_card,
  cardSelected,
  selectedPlayerInfo = {},
  buttonText,
  buttonPress,
  handleRollButtonClick = () => {},
  handleCardSelectClick = () => {},
  showSelectedPlayer = true,
  isDiceSpecial6 = false,buzzer_sound,default_audio_effect
}) => {
  const dispatch = useDispatch();

  const selctPlayer = (info) => {
    dispatch(set_ct_selected_player(info));
  };
  const handleCardSelect = (card) => {
    dispatch(set_ct_selected_card(card));
    handleCardSelectClick();
  };
  const cardImageFunction = (type) => {
    switch (type) {
      case "tech":
        return tech;
      case "mythos":
        return mythos;
      case "aliens":
        return aliens;
      case "random":
        return random;
      default:
        return schemes;
    }
  };
  const playerCardSymbolFunction = (type) => {
    switch (type) {
      case "tech":
        return ctTechCircleSymbol;
      case "mythos":
        return ctMythosCircleSymbol;
      case "aliens":
        return ctAliensCircleSymbol;
      case "random":
        return ctRandomCircleSymbol;
      case "schemes":
        return ctSchemesCircleSymbol;
      default:
        return CTDash2;
    }
  };
 
  useEffect(() => {
    if (  !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, default_audio_effect,playerSelected]);
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="high-five-wrapper "
      style={{ width: "100%" }}
    >
      {playerSelected === null ? (
        playersWithCardInfo?.map((value, index) => (
          <div
            className="player-flex"
            onClick={() => selctPlayer(value?.id)}
            key={index}
          >
            <div className="img-box">
              <img src={value?.profile_image} className="img-fluid" alt="" />
            </div>
            <p className="name mb-0">{value?.display_name}</p>
            <div className="icons">
              {!isDiceSpecial6 && (
                <img src={hammer} className="img-hammer" alt="" />
              )}
              <br />
              {Object.entries(value.cards).map((val, key) => {
                return val[1] > 0 ? (
                  <img
                    key={key}
                    src={playerCardSymbolFunction(val[0])}
                    className="circle-image"
                    alt=""
                  />
                ) : (
                  <img
                    key={key}
                    src={CTDash2}
                    className="circle-image"
                    alt=""
                  />
                );
              })}
            </div>
          </div>
        ))
      ) : _.isEmpty(cardSelected) ? (
        <>
          {showSelectedPlayer && (
            <div className="player-flex">
              <div className="img-box">
                <img
                  src={selectedPlayerInfo?.profile_image}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <p className="name mb-0">{selectedPlayerInfo?.display_name}</p>
              <div className="icons">
                {!isDiceSpecial6 && (
                  <img src={hammer} className="img-hammer" alt="" />
                )}
                <br />

                {Object.entries(selectedPlayerInfo?.cards).map((val, key) => {
                  return val[1] > 0 ? (
                    <img
                      key={key}
                      src={playerCardSymbolFunction(val[0])}
                      className="circle-image"
                      alt=""
                    />
                  ) : (
                    <img
                      key={key}
                      src={CTDash2}
                      className="circle-image"
                      alt=""
                    />
                  );
                })}
              </div>
            </div>
          )}
          <motion.div className="high-cards-flex">
            {Object.entries(selectedPlayerInfo?.cards).map((value, index) => {
              return (
                <>
                  {value[1] > 0 && (
                    <motion.div
                      variants={staticBounceVariants}
                      className="card"
                      onClick={() => handleCardSelect(value[0])}
                    >
                      <img
                        src={cardImageFunction(value[0])}
                        className="img-fluid"
                        alt=""
                      />
                      {value[1] > 1 && (
                        <img
                          src={cardImageFunction(value[0])}
                          className="img-fluid img1 "
                          alt=""
                        />
                      )}
                    </motion.div>
                  )}
                </>
              );
            })}
          </motion.div>
        </>
      ) : (
        <motion.div variants={staticBounceVariants} className="high-cards-flex">
          <div className="card">
            <img src={tech} className="img-fluid" alt="" />
          </div>
          <button
            className="ct-btn-gray green-btn"
            onClick={() => handleRollButtonClick()}
          >
            {buttonText}
          </button>
        </motion.div>
      )}
    </motion.div>
  );
};

export default CtHighFivePlayerList;
